/**
 * Infinite scroll for collection (and search) product grids.
 * Loads the next paginated page when the sentinel enters the viewport.
 */
(function () {
  var observer = null;
  var loading = false;
  var nextUrl = '';

  function getElements() {
    return {
      grid: document.getElementById('product-grid'),
      sentinel: document.getElementById('InfiniteScrollSentinel'),
      status: document.querySelector('.pagination-block .collection-product-count'),
      spinner: document.getElementById('InfiniteScrollLoading')
    };
  }

  function setLoading(isLoading) {
    loading = isLoading;
    var els = getElements();
    if (els.spinner) {
      els.spinner.hidden = !isLoading;
      els.spinner.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    }
  }

  function disconnect() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function updateFromSentinel(sentinel) {
    nextUrl = sentinel && sentinel.dataset.nextUrl ? sentinel.dataset.nextUrl : '';
    if (!nextUrl && sentinel) {
      sentinel.hidden = true;
    }
  }

  function loadMore() {
    if (loading || !nextUrl) return;

    var els = getElements();
    if (!els.grid || !els.sentinel) return;

    setLoading(true);
    var requestUrl = nextUrl;

    fetch(requestUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load more products');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var newSentinel = doc.getElementById('InfiniteScrollSentinel');
        var newStatus = doc.querySelector('.pagination-block .collection-product-count');

        if (newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (item) {
            els.grid.appendChild(item);
          });
        }

        // Apply the same column classes used by the initial grid (2/3/4 across)
        if (typeof window.setGridLayout === 'function') {
          window.setGridLayout();
        }

        if (els.status && newStatus) {
          var total = els.sentinel.dataset.total || newSentinel && newSentinel.dataset.total || '';
          var loaded = els.grid.children.length;
          if (total) {
            var label = els.status.textContent || '';
            // Rebuild using existing words when possible: "Showing 1-X of Y items"
            var ofMatch = label.match(/^(.*?\s)(\d+)(\s*[-–]\s*)?(\d+)?(\s+)(.*?\s)(\d+)(\s+)(.*)$/);
            if (ofMatch) {
              els.status.textContent = ofMatch[1] + '1-' + loaded + ofMatch[5] + ofMatch[6] + total + ofMatch[8] + ofMatch[9];
            } else {
              els.status.innerHTML = newStatus.innerHTML;
            }
          } else {
            els.status.innerHTML = newStatus.innerHTML;
          }
        }

        if (newSentinel) {
          els.sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl || '';
          updateFromSentinel(els.sentinel);
        } else {
          nextUrl = '';
          els.sentinel.hidden = true;
        }

        // Trigger lazysizes for newly added images if present
        if (window.lazySizes && typeof window.lazySizes.autoSizer === 'object') {
          window.lazySizes.autoSizer.checkElems();
        }
      })
      .catch(function () {
        // Keep sentinel visible so the user can retry by scrolling again
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function init() {
    disconnect();
    loading = false;

    var els = getElements();
    if (!els.grid || !els.sentinel) return;

    updateFromSentinel(els.sentinel);
    if (!nextUrl) {
      els.sentinel.hidden = true;
      return;
    }

    els.sentinel.hidden = false;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadMore();
        });
      },
      { rootMargin: '400px 0px' }
    );
    observer.observe(els.sentinel);
  }

  function observeGridContainer() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || typeof MutationObserver === 'undefined') return;

    var mo = new MutationObserver(function () {
      init();
    });
    mo.observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observeGridContainer();
    });
  } else {
    init();
    observeGridContainer();
  }

  window.CollectionInfiniteScroll = { init: init };
})();
